export default __webpack_public_path__ + "static/our app feature-35fd7e177ddb3fd4e1d1315fe3e5cf32.png";